import { useState, useEffect } from "react";
import { FetchForwardApi } from "../services/forwardService";

export const useForwardLst = (search, messageId, chatUniqueId, pageFrom) => {
  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserList = async () => {
      try {
        setIsLoading(true);
        const response = await FetchForwardApi(
          `&search=${search}&message_id=${messageId}&chat_unique_id=${chatUniqueId}&key_word=${pageFrom}`
        );
        setUser(response?.get_forward_msg_list || []); // update with correct response format
      } catch (error) {
        console.error("Failed to fetch users:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserList(); // Call the function when component mounts or search changes
  }, [search, chatUniqueId, messageId, pageFrom]);

  return {
    isLoading,
    user,
  };
};
